import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import DetailDialog from '../../widgets/DetailDialog';

const CRUDDetailDialog = (props) => {
  const {
    routes,
    icons,
    ComponentContent,
  } = props;
  const history = useHistory();

  const handleClose = (e) => {
    e.stopPropagation();
    history.goBack();
  };

  const { ComponentContent: Comp, ...contentProps } = props;

  return (
    <DetailDialog
      titleId={routes.detail.titleId}
      open
      onClose={handleClose}
      icons={icons}
    >
      <ComponentContent
        {...contentProps}
      />
    </DetailDialog>
  );
};

CRUDDetailDialog.propTypes = {
  routes: PropTypes.shape({
    detail: PropTypes.shape({
      titleId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  icons: PropTypes.objectOf(PropTypes.object).isRequired,
  ComponentContent: PropTypes.func.isRequired,
};

CRUDDetailDialog.defaultProps = {

};

export default CRUDDetailDialog;
